export default __webpack_public_path__ + "static/media/checkmark.7ca574f2.svg";